import { AxiosMULEEX } from "../apiConfig";

import { orgId } from "../apiConfig";

export const securityPolicyApiFactory = {
  $_verifyUser(payload) {
    let url = "/security/activate";
    return AxiosMULEEX.patch(url, payload);
  },
  $_getSecurityQuestions() {
    let url = "/security/get-all-security-question";
    return AxiosMULEEX.patch(url, { orgId: orgId() });
  },
  $_deleteSecurityQuestion(payload) {
    let url = "/security/delete-question";
    payload.orgId = orgId();
    return AxiosMULEEX.patch(url, payload);
  },
  $_updateSecurityQuestion(payload) {
    let url = "/security/update-security-question-for-user";
    // payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_updatePasswordSettings(payload) {
    let url = "/password/security";
    payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_submitSecurityQuestions(payload) {
    let url = "/security/createOrgSecurity";
    payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_updateTwoFactorAuthOptions(payload) {
    let url = "/security/twofactorauth";
    payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_updateTwoFAOptions(payload) {
    let url = "/security/update-twoFA";
    payload.orgId = orgId();
    return AxiosMULEEX.post(url, payload);
  },
  $_confirmPassword(payload) {
    let url = "/security/confirm-password";
    return AxiosMULEEX.post(url, payload);
  },
  $_sendToken(payload) {
    let url = "/security/two-factor/send-token";
    return AxiosMULEEX.post(url, payload);
  },
  $_getTwoFactorStatus(userId) {
    let url = `/security/two-factor/status/${userId}`;
    return AxiosMULEEX.get(url);
  },
  $_enableTwoFA(payload) {
    let url = "/security/two-factor/enable";
    return AxiosMULEEX.post(url, payload);
  },
  $_disableTwoFA(payload) {
    let url = "/security/two-factor/disable";
    return AxiosMULEEX.post(url, payload);
  },
  // $_activateTwoFA(payload) {
  //   let url = "/security/activateTwoFA";
  //   return AxiosMULEEX.patch(url, payload);
  // },
  $_createSecurityQuestion(payload) {
    let url = "/security/add-security-question";
    payload.forEach((item) => {
      item.orgId = orgId();
    });
    return AxiosMULEEX.post(url, payload);
  },
  $_validateTwoFactorAuthOTP(payload) {
    let url = "/security/validate";
    return AxiosMULEEX.post(url, payload);
  },
};
